// extracted by mini-css-extract-plugin
export var orderDetails = "_tw-2";
export var orderImage = "_tw-1";
export var orderMeta = "_tw-3";
export var orderSummary = "_tw-0";
export var rightArrow = "_tw-4";